module.exports = "div.w3-container {\r\n    max-width: 500px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shippingLines/shipping-line-form/shipping-line-form.component.css
// module id = ./src/app/components/shippingLines/shipping-line-form/shipping-line-form.component.css
// module chunks = main